import { render, staticRenderFns } from "./UserSignatures.vue?vue&type=template&id=3fc88f02&scoped=true&"
import script from "./UserSignatures.vue?vue&type=script&lang=js&"
export * from "./UserSignatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc88f02",
  null
  
)

export default component.exports